import React from 'react';

import Layout01 from './layout01';
import StationLegacy from './layout-station-legacy';

import { useBrandingData } from './dataProviders';
import { ReturnPolicyDialogProvider } from './components/ReturnPolicyDialog';


export const layouts = {
  layout01: Layout01,
  station_legacy: StationLegacy
};


export default function Layout() {
  const branding = useBrandingData();
  let layoutKey = branding.layout_key;

  if( !layoutKey || layoutKey === 'layout00' ) {
    layoutKey = 'layout01';
  }

  let TheLayout = layouts[layoutKey];

  if( !TheLayout ) {
    // eslint-disable-next-line no-console
    console.warn(`Missing layout ${layoutKey}`);
    TheLayout = layouts.layout01;
  }

  return (
    <ReturnPolicyDialogProvider>
      <TheLayout branding={branding} />
    </ReturnPolicyDialogProvider>
  );
}
